"use client";

import { openConsentSettings } from "@/lib/consent/store";

interface CookieSettingsButtonProps {
  label: string;
  className?: string;
}

/** Reopens the consent banner; focus returns here when it closes. */
export function CookieSettingsButton({
  label,
  className,
}: CookieSettingsButtonProps) {
  return (
    <button
      className={className}
      type="button"
      onClick={(event) => openConsentSettings(event.currentTarget)}
    >
      {label}
    </button>
  );
}
